package com.example.mystybag.appCore.model

import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

data class NotificationsUIState(
    val notifications           : List<NotificationsVisualModel>    = emptyList(),
    val isLoading               : Boolean                           = true,
    val showDatePickerDialog    : Boolean                           = false,
    val selectableDates         : Pair<Long?, Long?>                = Pair(null, Clock.System.now().toEpochMilliseconds()),
    val yearsList               : List<Int>                         = (2012 .. Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).year).toList(),
    val selectedStartDate       : Long?                             = null,
    val selectedEndDate         : Long?                             = null,
    val filteredDates           : String?                           = null
)